// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"99c29194010a2bbf1663","811":"69e1def1fe1ac98f2eed"}[chunkId] + ".js");